import MuiTablePagination, {
  type TablePaginationProps as MuiTablePaginationProps,
} from '@mui/material/TablePagination';
import { forwardRef, type ReactElement } from 'react';
import { tablePaginationRootSx } from './tablePaginationChrome';
import { TablePaginationPageActions } from './TablePaginationPageActions';

type TablePaginationBaseProps = Omit<MuiTablePaginationProps, 'component'>;

export const TablePaginationBase = forwardRef<HTMLDivElement, TablePaginationBaseProps>(
  ({ ActionsComponent = TablePaginationPageActions, sx, ...props }, ref): ReactElement => (
    <MuiTablePagination
      ActionsComponent={ActionsComponent}
      component="div"
      ref={ref}
      sx={
        (sx
          ? [tablePaginationRootSx, sx]
          : [tablePaginationRootSx]) as MuiTablePaginationProps['sx']
      }
      {...props}
    />
  ),
);

TablePaginationBase.displayName = 'TablePaginationBase';
